import config from "@Config/index";
import axios from "axios";

const fetchInstallmentPlans = async ({ id, regionId, selectedLang }: any, additionalParams: any = {}) => {
  
  const params = {
    type: "",
    region_id: regionId,
    lang: selectedLang || "en",
    cache: "false",
    methods: "number_of_installments",
    ...additionalParams,
  };

  const optionHeaders: any = {};

  return axios.get(`${config.API_URL}/api/v0/inventories/${id}/installment_plans`, {
    params,
    withCredentials: true,
    ...optionHeaders,
  });
};

export default fetchInstallmentPlans;
